export default __webpack_public_path__ + "static/media/logo-sygnet.icon.7b9bdc6a.svg";